import { gql } from '@mineko/graphql-client';

export default gql`
  mutation ($input: CreateOrderCartInput!) {
    CreateOrderCart(input: $input) {
      id
    }
  }
`;
